<template>
  <div class="app">
    <!-- <div class="fade" v-if="this.active==2">

    </div> -->
    <div class="mui-card">
      <!--      <div class="mui-card-footer">-->
      <!--        <span class="mui-card-footer-left" style="width: 35%">所在建筑名称：</span>-->
      <!--        <span>{{ name }}</span>-->
      <!--      </div>-->
      <!--      <div class="mui-card-footer">-->
      <!--        <span class="mui-card-footer-left" style="width: 35%">所在位置：</span>-->
      <!--        <div class="mui-card-footer-right" style="width: 60%">-->
      <!--          <input v-model="locationRemark" :disabled="active==2" name="exitBlindFlag" value="1" class="input-text" type="text"-->
      <!--                 placeholder="请输入位置描述">-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="mui-card-footer rejectionRemarkArea" v-if="rejectionRemark">
        <span class="mui-card-footer-left" style="flex-shrink: 0"
          >驳回备注：</span
        >
        <span style="color: red">{{ rejectionRemark }}</span>
      </div>
      <div class="mui-card-footer" style="border-bottom: 1px solid #ccc">
        <span class="mui-card-footer-left" style="width: 100px"
          >建筑物评价：</span
        >
        <!--           <Rate :score="score" :readonly="active==2" v-on:getScore="getScore"></Rate>-->
        <div class="scoreiconlist">
          <div class="scoreicon" @click="changescore(1)">
            <img
              src="../../assets/xl.png"
              alt=""
              :class="this.score == 1 ? 'scoreicon_act' : ''"
            />
          </div>
          <div class="scoreicon" @click="changescore(2)">
            <img
              src="../../assets/yb.png"
              alt=""
              :class="this.score == 2 ? 'scoreicon_act' : ''"
            />
          </div>
          <div class="scoreicon" @click="changescore(3)">
            <img
              src="../../assets/kl.png"
              alt=""
              :class="this.score == 3 ? 'scoreicon_act' : ''"
            />
          </div>
        </div>
      </div>

      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 100px"
          >建筑物图片：</span
        >
        <div class="img-files flex">
          <div v-if="imgs.length > 0" class="flex">
            <div class="img-box" v-for="(item, i) in imgs" :key="i">
              <img :src="item" alt="" v-image-preview />
              <span @click="del(i)" v-if="active != 2"
                ><i class="mui-icon mui-icon-close"></i
              ></span>
            </div>
          </div>
          <div class="img-file" v-if="imgs.length < size">
            <input
              type="file"
              id="files"
              accept="image/*"
              ref="updateFiles"
              @change="fileChange"
            />
          </div>
        </div>
        <span class="img-add-class" v-if="active != 2">
          <span class="mui-icon mui-icon-plus" @click="clickUpdateImage"></span>
        </span>
      </div>

      <div class="mui-card">
        <span
          style="
            color: rgb(109, 109, 114);
            line-height: 35px;
            display: inline-block;
            width: 100%;
            padding-left: 5px;
          "
          >信息</span
        >
        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 100px"
              >开放时间：</span
            >
            <div
              class="mui-numbox mui-card-footer-right"
              style="
                width: calc(100% - 100px);
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <input
                :disabled="active == 2"
                style="width: 40%; margin: 0; padding: 0"
                type="text"
                @click.prevent="openstartpick"
                v-model="formItem.starttime"
                readonly
              />
              ——
              <input
                :disabled="active == 2"
                style="width: 40%; margin: 0; padding: 0"
                type="text"
                @click.prevent="openendpick"
                v-model="formItem.endtime"
                readonly
              />

              <mt-datetime-picker
                ref="startpicker"
                type="time"
                @confirm="handleConfirm_start"
              >
              </mt-datetime-picker>

              <mt-datetime-picker
                ref="endpicker"
                type="time"
                @confirm="handleConfirm_end"
              >
              </mt-datetime-picker>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 100px"
              >服务热线：</span
            >
            <div class="mui-card-footer-right" style="width: calc(100% - 100px">
              <input
                :disabled="active == 2"
                type="number"
                name="phone"
                v-model="formItem.phone"
                placeholder="请输入服务热线"
              />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 48%"
              >无障碍通行是否方便：</span
            >
            <div class="mui-card-footer-right">
              <span class="span-input-radio">
                <input
                  v-model="formItem.isfb"
                  name="isfb"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />是
              </span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.isfb"
                  name="isfb"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />否
              </span>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 40%"
              >无障碍停车位：</span
            >
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.carport"
                  name="carport"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.carport"
                  name="carport"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无</span
              >
            </div>
          </div>
        </div>

        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left" style="width: 150px"
              >无障碍设施是否完善：</span
            >
            <div class="mui-card-footer-right">
              <span class="span-input-radio"
                ><input
                  v-model="formItem.devicecomplete"
                  name="devicecomplete"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />是</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.devicecomplete"
                  name="devicecomplete"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />否</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="mui-card-footer">
        <span
          class="mui-card-footer-left"
          style="width: 40%; padding-bottom: 40px"
          >无障碍整体感受：</span
        >
        <span v-if="active != 2">
          <textarea
            name=""
            cols="30"
            rows="10"
            v-model="textAreaValue"
          ></textarea>
          <span class="mui-badge" @click="addComment('非常方便')" ref="comment1"
            >非常方便</span
          >
          <span
            class="mui-badge"
            @click="addComment('完全无障碍')"
            ref="comment2"
            >完全无障碍</span
          >
          <span
            class="mui-badge"
            @click="addComment('设施完好，赞！')"
            ref="comment3"
            >设施完好，赞！</span
          >
        </span>
        <span v-else>
          <textarea
            name=""
            :disabled="active == 2"
            cols="30"
            rows="10"
            v-model="textAreaValue"
            style="margin-bottom: 0"
          ></textarea>
        </span>
      </div>
    </div>
    <div v-if="this.buildinginfo.buildingtype_id === 5" class="mui-card">
      <span
        style="
          color: rgb(109, 109, 114);
          line-height: 35px;
          display: inline-block;
          width: 100%;
          padding-left: 5px;
        "
        >无障碍换乘描述</span
      >

      <div class="card">
        <div class="mui-card-footer-div">
          <span class="mui-card-footer-left" style="width: 150px"
            >换乘站：</span
          >
          <div class="mui-card-footer-right">
            <span class="span-input-radio"
              ><input
                v-model="formItem.ishcz"
                name="ishcz"
                value="1"
                class="input-radio"
                type="radio"
                :disabled="active == 2"
              />是</span
            >
            <span class="span-input-radio"
              ><input
                v-model="formItem.ishcz"
                name="ishcz"
                value="0"
                class="input-radio"
                type="radio"
                :disabled="active == 2"
              />否</span
            >
          </div>
        </div>
      </div>

      <div class="mui-card" v-if="formItem.ishcz == 1" style="width: 100%">
        <div class="card">
          <span>站内指南</span>
          <hr />
          <span style="padding: 10px 0">
            {{ this.buildinginfo.name }}是{{ this.buildinginfo.city
            }}{{ line }}的换乘站。
          </span>
          <hr />

          <div
            class=""
            style="
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              line-height: 50px;
            "
          >
            <span>无障碍出入口位于</span>
            <select
              style="width: 100px; padding: 0"
              name="crk_pos"
              text-align-last:center
              v-model="formItem.crk_pos"
              id=""
            >
              <option
                :value="item"
                v-for="(item, index) in this.formItem.linelist"
              >
                {{ item }}
              </option>
            </select>
            站厅的
            <input
              style="width: 30px; padding: 0; margin: 0"
              type="number"
              v-model="formItem.crk_number"
            />
            号出入口。
          </div>
          <hr />
          <!--地面到站厅部分-->
          <div style="padding: 10px 0; line-height: 50px">
            <div class="ground-stationhall">
              <span>地面层到站厅层是</span>
              <select
                v-model="formItem.dmc_zt"
                style="width: 100px; margin: 0; text-align-last: center"
              >
                <option value="无障碍电梯" selected>无障碍电梯</option>
                <option value="爬楼车">爬楼车</option>
                <option value="楼梯升降机">楼梯升降机</option>
                <option value="升降平台">升降平台</option>
              </select>
            </div>
            <div class="ground-stationhall-radio">
              <span>是否需要求助地铁工作人员</span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.needhelp"
                  name="needhelp"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />需要
              </span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.needhelp"
                  name="needhelp"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />不需要
              </span>
            </div>
            <div class="ground-stationhall-evaluate">
              <span>目前设施的完整性：</span>
              <select
                v-model="formItem.deviceisok"
                style="width: 50px; text-align-last: center"
              >
                <option value="完好">完好</option>
                <option value="停用">停用</option>
                <option value="损坏">损坏</option>
              </select>
            </div>
          </div>
          <hr />
          <!--站厅到站台层的部分-->
          <div style="line-height: 50px">
            <div class="stationhall-platform">
              <span>站厅层到站台层是</span>
              <select
                v-model="formItem.zt_dmc"
                style="width: 100px; text-align-last: center"
              >
                <option value="无障碍电梯" selected>无障碍电梯</option>
                <option value="爬楼车">爬楼车</option>
                <option value="楼梯升降机">楼梯升降机</option>
                <option value="升降平台">升降平台</option>
              </select>
            </div>
            <div class="stationhall-platform-radio">
              <span>是否需要求助地铁工作人员</span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.needhelpfor_zt_dmc"
                  name="needhelpfor_zt_dmc"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />需要
              </span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.needhelpfor_zt_dmc"
                  name="needhelpfor_zt_dmc"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />不需要
              </span>
            </div>
            <div class="stationhall-platform-evaluate">
              <span>目前设施的完整性：</span>
              <select
                v-model="formItem.deviceisokfor_zt_dmc"
                style="width: 50px; text-align-last: center"
              >
                <option value="完好">完好</option>
                <option value="停用">停用</option>
                <option value="损坏">损坏</option>
              </select>
            </div>
          </div>
          <hr />
          <!--是否有无障碍厕所的盒子-->
          <div style="line-height: 50px">
            <div>
              <span>本站是否建有无障碍厕所</span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.has_wza_cs"
                  name="has_wza_cs"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />有
              </span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.has_wza_cs"
                  name="has_wza_cs"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />无
              </span>
            </div>
            <!--v-show="formItem.has_wza_cs - 0"-->
            <div v-show="formItem.has_wza_cs - 0">
              <span>是否为第三卫生间</span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.is_dlkj"
                  name="is_dlkj"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />是
              </span>
              <span class="span-input-radio">
                <input
                  v-model="formItem.is_dlkj"
                  name="is_dlkj"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />否
              </span>
            </div>
          </div>
        </div>

        <div class="card">
          <span>换乘指南</span>

          <!--          <div v-for="(item,index) in this.formItem.linelist" style="padding: 10px 0;">-->
          <!--            本站可与{{ item.trim() }}换乘，换乘-->

          <!--            <span class="span-input-radio"><input v-model="formItem.hcfb_[index]" :name="'hcsffb_'+[index]"-->
          <!--                                                  value="1"-->
          <!--                                                  class="input-radio"-->
          <!--                                                  type="radio" :disabled="active==2">方便</span>-->
          <!--            <span class="span-input-radio"><input v-model="formItem.hcfb_[index]" :name="'hcsffb_'+[index]"-->
          <!--                                                  value="0"-->
          <!--                                                  class="input-radio"-->
          <!--                                                  type="radio" :disabled="active==2">不方便</span>-->

          <!--          </div>-->
          <hr />
          <div
            class="line-row"
            v-for="(item, index) in this.formItem.line_arr_2"
          >
            {{ item[0] }}与{{ item[1] }}换乘
            <div>
              <span class="span-input-radio"
                ><input
                  v-model="formItem.hcfb[index]"
                  :name="'hcfb' + [index]"
                  value="1"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />方便</span
              >
              <span class="span-input-radio"
                ><input
                  v-model="formItem.hcfb[index]"
                  :name="'hcfb' + [index]"
                  value="0"
                  class="input-radio"
                  type="radio"
                  :disabled="active == 2"
                />不方便</span
              >
            </div>
            <hr />
          </div>
        </div>

        <!--        <div class="card">-->
        <div class="mui-card-footer">
          <span
            class="mui-card-footer-left"
            style="width: 40%; padding-bottom: 40px"
            >无障碍换乘感受：</span
          >
          <span v-if="active != 2">
            <textarea
              name=""
              cols="30"
              rows="10"
              v-model="formItem.grgs"
            ></textarea>
            <span
              class="mui-badge"
              @click="addComment_('非常方便')"
              ref="comment1"
              >非常方便</span
            >
            <span
              class="mui-badge"
              @click="addComment_('完全无障碍')"
              ref="comment2"
              >完全无障碍</span
            >
            <span
              class="mui-badge"
              @click="addComment_('设施完好，赞！')"
              ref="comment3"
              >设施完好，赞！</span
            >
          </span>
          <span v-else>
            <textarea
              name=""
              :disabled="active == 2"
              cols="30"
              rows="10"
              v-model="textAreaValue"
              style="margin-bottom: 0"
            ></textarea>
          </span>
        </div>
        <!--        </div>-->
      </div>
    </div>

    <div class="mui-card" v-if="this.active === '1' || this.active === '3'">
      <mt-button type="primary" @click="clickSubmit">上传</mt-button>
    </div>
    <div class="mui-card" v-if="showReEditBtn">
      <mt-button type="primary" @click="reEdit">重新编辑</mt-button>
    </div>
  </div>
</template>

<script>
import Rate from "../common/Rate";
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import { compressImage,compressImageWithout } from '../../utils/compressImage'
import {getUserLocation,configureWechatSDK} from '../../utils/wechatSDK'
import {generateRandomFileName,ossClient} from "../../utils/oss_config"
export default {
  name: "overview",
  data() {
    return {
      textAreaValue: "",
      // locationRemark: '',
      formItem: {
        starttime: "08:00",
        endtime: "22:00",
        isfb: "1",
        phone: "",
        carport: "1",
        devicecomplete: "1",
        ishcz: "1",
        hcfb: [], //换乘是否方便列表
        crk_pos: "", //出入口位于
        crk_number: "", //出入口
        linelist: {},
        line_arr_2: [],
        needhelp: "0", //是否需要求助地铁工作人员
        deviceisok: "完好", //设施时是否完好
        dmc_zt: "无障碍电梯", //地面层到站厅
        zt_dmc: "无障碍电梯",
        needhelpfor_zt_dmc: "0",
        deviceisokfor_zt_dmc: "完好",
        has_wza_cs: "1", //是否有无障碍厕所
        is_dlkj: "1", //是否第三卫生间
        hcsf_fb: "0", //换成是否方便
        // hcfb_: [],
        grgs: "", //个人感受
      },
      returnImgs: [],
      score: 1,
      imgs: [],
      imgfiles: [],
      size: 5,
      title: "建筑物概述",
      active:
        this.$route.params.active == "20" ? "2" : this.$route.params.active,
      showReEditBtn: this.$route.params.active == "20" ? true : false, //当是自己的上报记录且审核状态为待审核或审核驳回时，显示重新编辑按钮，点击后切换为编辑模式
      task_id: this.$route.params.taskId,
      building_id: this.$route.params.buildingId,
      buildingdevicetype_id: this.$route.params.facilitiesTypeId,
      id: this.$route.params.id,
      host: process.env.BASE_URL,
      name: "",

      //用于存储storage
      savedata: {},
      buildinginfo: {}, //建筑物详情,
      currentPosi: [], //当前位置坐标
      rejectionRemark: "", //驳回备注
    };
  },
  created() {
    this.$emit("getTitle", this.title);
    this.getChildBuildingInfo();
    this.initMsg();

    var that = this;
    var getCurrentLocationInterval = setInterval(function () {
      that.getData(that, that.currentPosi, function () {
        clearInterval(getCurrentLocationInterval);
      });
    }, 1000);
    //销毁定时器
    this.$once("hook:beforeDestroy", () => {
      clearInterval(getCurrentLocationInterval);
    });

    // localStorage.setItem(this.building_id+','+this.buildingdevicetype_id,JSON.stringify(this.savedata))
    // this.insertdata();
  },
  methods: {
    submitImageWithOss(imgId,fileExtension){
      Indicator.open("上传中...");
      
      const file = this.imgfiles[imgId].get('file');
      const fileName = generateRandomFileName(fileExtension); // 自定义文件名

      ossClient.put(fileName, file).then(result => {
        // 上传成功
        const imageUrl = result.url; // 上传成功后返回的图片URL
        this.returnImgs.push(imageUrl);
        Indicator.close();
        Toast("上传成功")
      }).catch(error => {
        // 上传失败
        console.error('Failed to upload the image:', error);
      });

    },
    changescore(v) {
      if (this.active == 2) {
        return;
      }

      this.score = v;
    },
    insertdata() {
      let savedata = localStorage.getItem(
        this.building_id + "," + this.buildingdevicetype_id
      );

      if (savedata === null || savedata === undefined || savedata === "") {
        return;
      } else {
        Toast("已自动导入上一次数据");
      }

      //      自己导入存储数据
      let savedataobj = JSON.parse(savedata);

      if (savedataobj.formItem) {
        this.formItem = savedataobj.formItem;
      }
      // if (savedataobj.locationRemark) {
      //   this.locationRemark = savedataobj.locationRemark
      // }
      if (savedataobj.score) {
        this.score = savedataobj.score;
      }
      if (savedataobj.textAreaValue) {
        this.textAreaValue = savedataobj.textAreaValue;
      }
    },
    clickUpdateImage() {
      this.$refs.updateFiles.click();
    },
    fileChange() {
      var _this = this
      var event = window.event
      var file = event.target.files
      var reader = new FileReader()
      let formData = new FormData()
      const fileName = file[0].name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
      compressImageWithout(file[0], 800000, 6000000, 0.4).then((res) => {
        // console.log('压缩之后图片尺寸大小: ', res.size / 1024)
        // console.log('实际压缩率： ', ((file[0].size - res.size) / file[0].size * 100).toFixed(2) + '%');
        formData.append('file', new File([res], 'my-image1.png', { type: 'image/png' }))
        _this.imgfiles.push(formData)
        reader.readAsDataURL(new File([res], 'my-image1.png', { type: 'image/png' }))
        reader.onload = function (e) {
          _this.imgs.push(e.target.result)
        }
        // _this.submitImage(0)
        _this.submitImageWithOss(0,fileExtension)
        this.imgfiles.splice(0, 1)
      })

    },
    del(i) {
      this.imgs.splice(i, 1);
      this.returnImgs.splice(i, 1);
    },
    addComment(val) {
      if (this.textAreaValue === "") {
        this.textAreaValue = this.textAreaValue + val;
      } else {
        this.textAreaValue = this.textAreaValue + "," + val;
      }
    },
    addComment_(val) {
      if (this.formItem.grgs === "") {
        this.formItem.grgs = this.formItem.grgs + val;
      } else {
        this.formItem.grgs = this.formItem.grgs + "," + val;
      }
    },
    reEdit() {
      this.active = "3";
      this.showReEditBtn = false;
    },
    clickSubmit() {
      // if (this.locationRemark === '') {
      //   Toast('请输入位置信息')
      //   return false
      // }
      if (this.returnImgs.length == 0) {
        Toast("请上传设施图片");
        return false;
      }
      this.submitpostdata();
    },
    submitImage(imgId) {
      Indicator.open("上传中...");
      this.$http
        .post("api/gather/uplaodimg", this.imgfiles[imgId], {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (data) {
          Indicator.close();
          if (data.body.code === 1) {
            this.returnImgs.push(data.body.data.url);
          }
        })
        .catch((error) => {
          Indicator.close();
          Toast("网络错误！");
        });
    },
    submitpostdata() {
      Indicator.open("提交中...");
      if (this.active === "1") {
        this.$http
          .post(
            "api/gather/submitpostdata",
            {
              task_id: this.task_id,
              building_id: this.building_id,
              buildingdevicetype_id: this.buildingdevicetype_id,
              score: this.score,
              // 'positiondesc': this.locationRemark,
              devicedesc: this.formItem,
              desc: this.textAreaValue,
              images: this.returnImgs.join(","),
              position: this.currentPosi,
            },
            { emulateJSON: true }
          )
          .then(function (data) {
            Indicator.close();
            if (data.body.code === 1) {
              Toast("上传成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            } else {
              Toast(data.body.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      } else {
        this.$http
          .post(
            "api/gather/editpostdata",
            {
              id: this.id,
              task_id: this.task_id,
              building_id: this.building_id,
              buildingdevicetype_id: this.buildingdevicetype_id,
              score: this.score,
              // 'positiondesc': this.locationRemark,
              devicedesc: this.formItem,
              desc: this.textAreaValue,
              images: this.returnImgs.join(","),
            },
            { emulateJSON: true }
          )
          .then(function (data) {
            if (data.body.code === 1) {
              Indicator.close();
              Toast("上传成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            } else {
              Toast(data.body.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      }
    },
    getScore(score) {
      this.score = score;
    },
    initMsg() {
      if (this.active === "2" || this.active === "3") {
        this.$http
          .get("api/gather/checkPostInfo?id=" + this.id)
          .then(function (data) {
            if (data.body.code === 1) {
              data = data.body.data.info;
              data.devicedesc = JSON.parse(data.devicedesc);
              let Imgs = [];
              if (data.images) {
                Imgs = data.images.split(",");
              }
              this.rejectionRemark = data.remark;
              this.textAreaValue = data.desc;
              // console.log(data.devicedesc);
              this.formItem = data.devicedesc;
              // this.formItem.passagewayValue = data.devicedesc.passagewayValue
              // this.formItem.signFlag = data.devicedesc.signFlag
              this.score = data.score;
              this.formItem = data.devicedesc;
              // this.locationRemark = data.positiondesc
              for (let i = 0; i < Imgs.length; i++) {
                this.imgs[i] = this.host + Imgs[i];
                this.returnImgs[i] = Imgs[i];
              }
            } else {
              Toast(data.body.data.msg);
            }
          })
          .catch((error) => {
            Indicator.close();
            Toast("网络错误！");
          });
      } else {
        // this.insertdata()
      }
    },
    getChildBuildingInfo() {
      this.$http
        .get("api/gather/getChildBuildingInfo?id=" + this.building_id)
        .then(function (data) {
          if (data.body.code === 1) {
            this.name = data.body.data.list.building.name;
            this.buildinginfo = data.body.data.list.building;
            try {
              this.citylist();
            } catch (e) {}
          }
        })
        .catch((error) => {
          console.log(error);
          Indicator.close();
          Toast("网络错误！");
        });
    },
    openstartpick() {
      this.$refs.startpicker.open();
    },
    openendpick() {
      this.$refs.endpicker.open();
    },
    handleConfirm_start(v) {
      this.formItem.starttime = v;
    },

    handleConfirm_end(v) {
      this.formItem.endtime = v;
    },

    citylist() {
      this.buildinginfo.address = this.buildinginfo.address.replace(" ", "");

      this.formItem.linelist = this.buildinginfo.address.split(";");

      var line_arr_2 = [];
      var that = this;
      this.formItem.linelist.forEach(function (it1) {
        that.formItem.linelist.forEach(function (it2) {
          if (it1 !== it2) {
            line_arr_2.push([it1.trim(), it2.trim()]);
            // if (line_arr_2.length === 0) {
            //   line_arr_2.push([it1, it2])
            //   // console.log(it1,it2)
            // } else {
            //   let flag = 1;
            //   line_arr_2.forEach(item => {
            //     if (item[0] === it2 && item[1] === it1) {
            //       flag = 0
            //     }
            //   })
            //   if (flag == 1) {
            //     line_arr_2.push([it1, it2])
            //   }
            //
            //
            // }
          }
        });
      });
      this.formItem.line_arr_2 = line_arr_2;
      var _this = this;
      // console.log(line_arr_2)
      if (this.formItem.hcfb.length === 0) {
        line_arr_2.forEach(function () {
          _this.formItem.hcfb.push("1");
          // _this.formItem.hcfb_.push("1")
        });
      }
      // console.log(this.formItem.hcfb)
    },
  },
  components: {
    Rate: Rate,
  },
  computed: {
    line: function () {
      var citylist = this.formItem.linelist;

      this.formItem.crk_pos = this.formItem.linelist[0];
      try {
        return citylist.join("、");
      } catch (e) {
        return citylist;
      }
    },
    line_2() {},
  },
  watch: {
    formItem: {
      handler(newValue, oldValue) {
        this.savedata.formItem = newValue;
        localStorage.setItem(
          this.building_id + "," + this.buildingdevicetype_id,
          JSON.stringify(this.savedata)
        );
      },
      deep: true,
    },
    "formItem.ishcz": {
      handler(n, o) {},
      deep: true,
    },
    // locationRemark: function (newValue) {
    //   this.savedata.locationRemark = newValue;
    //   localStorage.setItem(this.building_id + ',' + this.buildingdevicetype_id, JSON.stringify(this.savedata))
    //
    // },
    score(newValue) {
      this.savedata.score = newValue;
      localStorage.setItem(
        this.building_id + "," + this.buildingdevicetype_id,
        JSON.stringify(this.savedata)
      );
    },
    textAreaValue(newValue) {
      this.savedata.textAreaValue = newValue;
      localStorage.setItem(
        this.building_id + "," + this.buildingdevicetype_id,
        JSON.stringify(this.savedata)
      );
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.app {
  margin-bottom: 15px;
}

.img-files {
  width: 70%;
  float: right;

  .flex {
    width: 85%;
    display: inline-block;
  }

  .img-box {
    width: 60px;
    height: 60px;
    position: relative;
    border: 1px solid #e6e6e6;
    margin-right: 10px;
    background-color: white;
    float: left;
    text-align: center;

    img {
      max-width: 60px;
      max-height: 60px;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    span {
      position: absolute;
      top: -10px;
      left: 48px;
      color: red;
      display: block;
    }

    &:hover span {
      display: block;
    }
  }

  .img-add-class {
    width: 10%;
  }
}

.img-file {
  display: NONE;
  align-items: center;

  > input {
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  > label {
    position: absolute;
    font-size: 14px;
    color: #333;
  }
}

.mui-card {
  button {
    width: 100%;
  }
}

.mui-card-header {
  font-size: 15px;
}

select {
  margin: 0px;
  padding: 0px;
  background-color: #efefef;
  text-align: center;
}

.mui-card-footer-left {
  width: 25%;
  display: inline-block;
  line-height: 35px;
}

.card {
  border-top: 1px solid #ccc;
  color: #6d6d72;
  padding: 10px 15px;

  .mui-card-footer-div {
    width: 100%;
    display: block;
    padding: 2px 0;

    .mui-card-footer-left {
      width: 25%;
      display: inline-block;
      line-height: 35px;
    }

    .mui-card-footer-right {
      display: inline-block;
      float: right;
      width: 135px;
      padding: 0;

      .mui-input-numbox {
        padding: 0;
        width: 100px;
      }

      .span-input-radio {
        width: 45%;
        display: inline-block;
        line-height: 35px;
      }
    }
  }
}

.line-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 10px 0;
}

.card > span:first-child {
  font-weight: bold;
  font-size: 20px;
}

.scoreiconlist {
  display: flex;
  align-items: center;
}

.scoreicon {
  padding: 0 10px;
}

.scoreicon > img {
  width: 30px;
  height: 30px;
}

.scoreicon_act {
  width: 50px !important;
  height: 50px !important;
}
select {
  border: 2px solid #c3c3c3 !important;
  text-align: center !important;
  background: #ffffff;
  font-weight: bold;
}
input {
  height: auto;
  text-align: center !important;
}
.rejectionRemarkArea {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Facilities/overview.vue